import React, { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { images } from "../../Assets/images";
import appStoreImg from "../../Assets/images/appStore.png";
import playStoreImg from "../../Assets/images/playstore.webp";
import "../../Assets/css/UpdateApp.css";

// Per-company store links — mirrors the COMPANY_CONFIG pattern in PlanExpired.jsx.
const COMPANY_STORE_URLS = {
  "0it02f": {
    appStoreUrl: "https://apps.apple.com/us/app/healthy-4life-scan/id6759244547",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.fourlife.app",
  },
  "8nn29": {
    appStoreUrl: "https://apps.apple.com/in/app/globalhealth-ai/id6749219388",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.globalhealthai.android",
  },
  "wu9zm8": {
    appStoreUrl: "https://apps.apple.com/in/app/globalhealth-brasil/id6774457666",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.globalhealthai.brazil",
  },
};

const getDeviceStore = () => {
  const companyKey = process.env.REACT_APP_COMPANY_ID;
  const { appStoreUrl, playStoreUrl } =
    COMPANY_STORE_URLS[companyKey] || COMPANY_STORE_URLS["0it02f"];

  const ua = navigator.userAgent || navigator.vendor || window.opera || "";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return { type: "ios", url: appStoreUrl };
  }
  if (/android/i.test(ua)) {
    return { type: "android", url: playStoreUrl };
  }
  return { type: "ios", url: appStoreUrl };
};

const whatsNew = [
  "Faster performance & smoother experience",
  "Enhanced security & stability fixes",
];


const UpdateApp = () => {
  const { logoUrl } = useContext(GlobalContext);
  const companyId = process.env.REACT_APP_COMPANY_ID;
  const store = getDeviceStore();

  const handleUpdate = () => {
    window.open(store.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="update-app-page">
      <div className="update-bg-blob update-bg-blob-1" />
      <div className="update-bg-blob update-bg-blob-2" />
      <div className="update-bg-blob update-bg-blob-3" />

      <div className="update-app-content">

        {/* Logo */}
        <div className="update-logo-wrapper">
          <div className="update-logo-ring">
            <img
              src={
                logoUrl ||
                (companyId === "wu9zm8"
                  ? images.brasilLogo
                  : companyId === "8nn29"
                    ? images.globalHealthLogo
                    : images.appLogo)
              }
              alt="App Logo"
              className="update-logo-img"
              onError={(e) => {
                e.target.onerror = null;
                if (companyId === "wu9zm8") e.target.src = images.brasilLogo;
                else if (companyId === "8nn29")
                  e.target.src = images.globalHealthLogo;
                else e.target.src = images.appLogo;
              }}
            />
          </div>
          <div className="update-badge-dot">!</div>
        </div>

        {/* Title */}
        <div className="update-title-section">
          <span className="update-tag">New Update</span>
          <h1 className="update-title">Update Available</h1>
          <p className="update-subtitle">
            A new version of the app is ready. Update now for the best experience.
          </p>
        </div>

        {/* What's New card */}
        <div className="update-card">
          <p className="update-card-heading">What's New</p>
          <ul className="update-features-list">
            {whatsNew.map((item, idx) => (
              <li key={idx} className="update-feature-item">
                <span className="update-feature-check">&#10003;</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Update button */}
        <button className="update-btn" onClick={handleUpdate}>
          <img
            src={store.type === "ios" ? appStoreImg : playStoreImg}
            alt={store.type === "ios" ? "App Store" : "Google Play"}
            className="update-btn-store-img"
          />
          <span>
            {store.type === "ios" ? "Update on App Store" : "Update on Google Play"}
          </span>
        </button>

        <p className="update-footer-note">
          Keep your app updated for the best experience.
        </p>
      </div>
    </div>
  );
};

export default UpdateApp;
